export default __webpack_public_path__ + "static/media/notification-sound.c15283e1.mp3";